import React, { PropTypes } from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';

const DollarAmount = ({ amount }) => (
  <span className="cp-dollar-amount">
    <FormattedMessage
      id="dollar_amount"
      values={{
        amount: <FormattedNumber value={amount} minimumFractionDigits={2} maximumFractionDigits={2} />
      }} />
  </span>
);

DollarAmount.propTypes = {
  amount: PropTypes.number
};

export default DollarAmount;



// WEBPACK FOOTER //
// ./app/components/borrowing/shared/DollarAmount/DollarAmount.jsx